<script setup>
// import moment from 'moment'
import moment from 'moment-timezone'
import { mediaUrl } from '@core/utils/mediaUrl'
import {useUsersStore, useRestaurantsStore, useUserGroupsStore} from "@/stores"
import {numberWithCommas, simulation, encodeUUID, restaurantUrlSegment} from '@/plugins/misc'
import {ref} from "vue"
import {requiredValidator, reservationPlatformUrlValidator, urlValidator} from "@validators"
import AppDateTimePicker from "@core/components/AppDateTimePicker.vue"
import {VForm} from "vuetify/components"
import {storeToRefs} from "pinia"

const props = defineProps({
  restaurant: {
    type: Object,
  },
})

const restaurantsStore = useRestaurantsStore()

const usersStore = useUsersStore()
let myUser = null
let isRunningInStandAlone = null;
({ myUser, isRunningInStandAlone } = storeToRefs(usersStore))

const userGroupsStore = useUserGroupsStore()
let restaurantUserGroups = null;
({ restaurantUserGroups  } = storeToRefs(userGroupsStore))

const valid = ref(true)

const editingEventSpace = ref(null)
const editingEventDescription = ref(null)

const choosingImage = ref(false)

const isConfirmDeleteDialogOpen = ref(false)

//
// const emit = defineEmits(['update:modelValue'])

const handleMediaSelection = selectedMedia => {
  // Do something with the selected media
  console.log(selectedMedia)
  if(selectedMedia){
    //rips out any ?t=9287439832749 that may have been added to refresh the image after cropping
    editingEventSpace.value.imageId = selectedMedia.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/)[0]
  } else{
    editingEventSpace.value.imageId = null
  }
  choosingImage.value = false
}

const imageIdValidator = value => {
  if (!value || value.trim() === '') {
    return 'Image is required'
  }
  
  return true
}
const saveEventSpace = eventSpace => {
  const isImageIdValid = imageIdValidator(eventSpace.imageId) === true

  if(valid.value && isImageIdValid){
    console.log(eventSpace)
    eventSpace.new = undefined
    eventSpace.editing = false
    restaurantsStore.updateEventSpaces(props.restaurant.id, props.restaurant.eventSpaces)

    // eventSpacesStore.saveEventSpace(eventSpace._id)
    editingEventSpace.value = null
  } else if(!isImageIdValid){
    alert("Image required, please add one and save again.")
  }
}
const saveEventDescription = async () => {
  editingEventDescription.value = false
  await restaurantsStore.updateEventDescription(props.restaurant.id, props.restaurant.eventDescription)
}
const deleteEventSpace = eventSpace => {
  console.log(eventSpace)

  //remove event space from the array
  props.restaurant.eventSpaces = props.restaurant.eventSpaces.filter(e => e != eventSpace)
  restaurantsStore.updateEventSpaces(props.restaurant.id, props.restaurant.eventSpaces)

}
const newEventSpace = () => {
  let theEventSpace = {editing:true, new:true  }
  props.restaurant.eventSpaces.push(theEventSpace)
  editingEventSpace.value = theEventSpace
}

const reorderEventSpace = (eventSpace, change) => {
  let index = props.restaurant.eventSpaces.indexOf(eventSpace)
  let newIndex = index + change
  if(newIndex >= 0 && newIndex < props.restaurant.eventSpaces.length){
    let temp = props.restaurant.eventSpaces[newIndex]
    props.restaurant.eventSpaces[newIndex] = eventSpace
    props.restaurant.eventSpaces[index] = temp
    restaurantsStore.updateEventSpaces(props.restaurant.id, props.restaurant.eventSpaces)
  }
}

const cancelEditingEventSpace = eventSpace => {
  console.log(eventSpace)
  if(eventSpace.new){
    props.restaurant.eventSpaces = props.restaurant.eventSpaces.filter(e => e != eventSpace)
  } else{
    restaurantsStore.getRestaurantByProfileId(props.restaurant.profileId)

    // eventSpacesStore.getEventSpaces()
    // eventSpace.editing = false;
    // editingEventSpace.value = null
  }
  eventSpace.editing = false
  editingEventSpace.value = null
}

const cancelEditingEventDescription = async () => {

  //This is not working and the props.restaurant does not seem to update
  await restaurantsStore.getRestaurantByProfileId(props.restaurant.profileId)
  editingEventDescription.value = null
}

const eventSpacesToShow = computed(() => {
  return props.restaurant.eventSpaces || []
})

//user's permission, if any, for current restaurant
const myPermission = computed(() => {
  //in restaurantUserGroups find a group where the props.restaurant._id matches and then in that groups userPermissions array find obejct that matches for email = myUser.value.email then return the "permission" key value in the same object that matched the email
  if(restaurantUserGroups.value?.length > 0){
    const theGroup = restaurantUserGroups.value.find(group => group?.restaurant?._id == props.restaurant._id)
    if(theGroup){
      const thePermission = theGroup.userPermissions.find(permission => permission.email == myUser.value.email)
      if(thePermission){
        return thePermission.permission
      }
    }
  }
})
</script>

<template>
  <div class="">
    <MediaChooserAndManager
      v-if="editingEventSpace && (myUser?.userLevel == 'admin' || myPermission)"
      v-model:is-dialog-visible="choosingImage"
      title="Choose an image"
      :preselected-media-ids="[editingEventSpace?.imageId]"
      crop-stencil="rectangle"
      :crop-aspect-ratio="16/9"
      :restaurant="restaurant"
      @media-selected="handleMediaSelection"
    />
    <ConfirmDialog
      v-model:is-dialog-visible="isConfirmDeleteDialogOpen"
      confirmation-msg="Are you sure you want to delete?"
      confirm-btn-text="Yes"
      cancel-btn-text="No"
      @confirm="deleteEventSpace(editingEventSpace); isConfirmDeleteDialogOpen = false;"
      @cancel=" isConfirmDeleteDialogOpen = false;"
    />

    <template v-if="!(myUser?.userLevel == 'admin' || myPermission) && (eventSpacesToShow?.length == 0 && !restaurant?.eventDescription)">
      <!--      <div class="text-xs text-center">nothing added yet</div> -->
      <div
        v-if="restaurant?.website"
        class="text-xs text-center mt-4"
      >
        <a
          :href="restaurant.website"
          target="_blank"
        >Visit restaurant website to view detail on spaces</a>
      </div>
    </template>

    <div
      v-if="!editingEventDescription && (myUser?.userLevel == 'admin' || myPermission) && restaurant"
      class="text-center mt-2"
    >
      <!--      <v-btn -->
      <!--        size="small" -->
      <!--        width="fit-content" -->
      <!--        class="profile-header-edit-button" -->
      <!--        variant="text" -->
      <!--        :prepend-icon="(restaurant.eventDescription ? 'mdi-edit' : 'mdi-plus')" -->
      <!--        density="compact" -->
      <!--        @click="editingEventDescription = true" -->
      <!--      >{{(restaurant.eventDescription ? 'Edit' : 'Share')}} Overview -->
      <!--      </v-btn> -->
    </div>
    <div v-if="editingEventDescription">
      <VTextarea
        v-model="restaurant.eventDescription"
        label="Events General Info"
        hint="Describe in general your event space offerings, what sets you apart, and buyout options."
        class=""
      />
      <!--      save button below -->
      <div
        class="text-center"
        style="margin-top: -20px;"
      >
        <VBtn
          size="small"
          width="fit-content"
          class="profile-header-edit-button"
          variant="text"
          density="compact"
          v-bind="props"
          @click="saveEventDescription"
        >
          Save
        </VBtn>
        <VBtn
          size="small"
          width="fit-content"
          class="profile-header-edit-button"
          variant="text"
          density="compact"
          v-bind="props"
          @click="cancelEditingEventDescription"
        >
          Cancel
        </VBtn>
      </div>
    </div>
    <div
      v-if="!editingEventDescription && restaurant?.eventDescription"
      class="mb-4"
    >
      <div class="text-xs">
        {{ restaurant?.eventDescription }}
      </div>
    </div>

    <div
      v-for="(item, itemIndex) in eventSpacesToShow"
      v-if="eventSpacesToShow?.length > 0"
      class="d-flex flex-column h-100 gap-2 mb-3"
    >
      <div
        v-if="item?.editing"
        class="space-card"
      >
        <VForm
          v-model="valid"
          validate-on="input blur submit"
          @submit.prevent="saveEventSpace(item)"
        >
          <div>
            <div class="flex flex-column align-center">
              <div
                class="mb-8 mt-4 max-content-width"
                @click="choosingImage = !choosingImage"
              >
                <div v-if="item.imageId">
                  <img
                    :src="mediaUrl(item.imageId, 'regular')"
                    class="w-100 flex-1-0"
                    style="max-height: 300px; object-fit: cover; border-radius: 0.2rem;"
                  >
                  <span class="text-sm text-primary cursor-pointer">Update image</span>
                </div>
                <div
                  v-else
                  class="avatar-fallback flex flex-row align-center justify-center"
                >
                  <span class="text-sm text-primary cursor-pointer"><VIcon
                    style="margin-left: -3px;"
                    size="22"
                    class="mr-1"
                  >mdi-image</VIcon><b>Add image</b></span>
                </div>
              </div>
            </div>
            <VTextField
              v-model="item.name"
              label="Space Name"
              autocomplete="null"
              class=""
              :rules="[requiredValidator]"
              required
            />
            <VTextField
              v-model="item.capacity"
              label="Seated Capacity"
              hint="Max number of people seated"
              autocomplete="null"
              class=""
              type="number"
            />
            <VTextField
              v-model="item.capacityStanding"
              label="Standing Capacity"
              hint="Max number of people standing "
              autocomplete="null"
              class=""
              type="number"
            />
            <div class="mb-2">
              Optional (but recommended)
            </div>
            <VSelect
              v-model="item.roomType"
              label="Space Type"
              :items="['Private (4 walls)', 'Private (walls/curtains)', 'Semi-Private (curtains/walls)', 'Semi-Private (secluded section)', 'Main Dining']"
            />
            <VCombobox
              v-model="item.seatingType"
              label="Seating Type(s)"
              :items="['One Large Table', 'Multiple Smaller Tables', 'Cocktail (Standing)']"
              multiple
              class="mb-8"
            />
            <VTextarea
              v-model="item.description"
              label="Description"
              autocomplete="null"
              class=""
              hint="e.g. 'Private room with a view of the kitchen'"
            />
            <VTextField
              v-model="item.url"
              label="URL"
              autocomplete="null"
              :rules="[urlValidator]"
            />
          </div>
          <div class="text-center">
            <VBtn
              size="small"
              width="fit-content"
              class="profile-header-edit-button"
              variant="text"
              density="compact"
              v-bind="props"
              type="submit"
            >
              Save
            </VBtn>
            <VBtn
              size="small"
              width="fit-content"
              class="profile-header-edit-button"
              variant="text"
              density="compact"
              v-bind="props"
              @click="cancelEditingEventSpace(item)"
            >
              Cancel
            </VBtn>
          </div>
        </VForm>
      </div>
      <template v-else>
        <div class="space-card">
          <a
            style="text-decoration: inherit; color: inherit;"
            :href="item.url"
            target="_blank"
          >
            <!--              <img :src="mediaUrl(item.imageId, 'regular')" class="w-100 flex-1-0" style="max-height: 300px; object-fit: cover; border-radius: 0.2rem;"/> -->
            <div class="eventSpaceImageContainer">
              <img
                :src="mediaUrl(item.imageId, 'regular')"
                class="eventSpaceImage"
              >
              <span class="eventSpaceTitle">{{ item.name }}</span>
            </div>
            <div>
              <div
                v-if="item.roomType"
                class="text-xs"
              >Space Type: {{ item.roomType }}</div>

              <div
                v-if="item.seatingType"
                class="text-xs"
              >Seating Type(s): {{ item.seatingType.join(', ') }}</div>
              <div
                v-if="item.capacity"
                class="text-xs"
              >Seated Capacity: {{ item.capacity }}</div>
              <div
                v-if="item.capacityStanding"
                class="text-xs"
              >Standing Capacity: {{ item.capacityStanding }}</div>
              <div
                v-if="item.description"
                class="text-xs mt-1 mb-1"
              >{{ item.description }}</div>
              <div
                v-if="item.url"
                class="text-xs text-primary"
              ><a :href="item.url" />view more here <VIcon size="x-small">mdi-external-link</VIcon></div>
            </div>
          </a>
          <div
            v-if="!editingEventSpace && (myUser?.userLevel == 'admin' || myPermission)"
            class="text-center"
          >
            <VBtn
              size="small"
              width="fit-content"
              class=""
              variant="text"
              prepend-icon="mdi-edit"
              density="compact"
              v-bind="props"
              @click="item.editing = true; editingEventSpace = item"
            >
              Edit
            </VBtn>
            <VBtn
              size="small"
              width="fit-content"
              class=""
              variant="text"
              prepend-icon="mdi-delete"
              density="compact"
              v-bind="props"
              @click="isConfirmDeleteDialogOpen = true; editingEventSpace = item"
            >
              Delete
            </VBtn>
            <template v-if="restaurant.eventSpaces.length > 1">
              <VBtn
                v-if="itemIndex > 0"
                size="small"
                width="fit-content"
                class=""
                variant="text"
                append-icon="mdi-arrow-up"
                density="compact"
                v-bind="props"
                @click="reorderEventSpace(item, -1)"
              />
              <VBtn
                v-if="itemIndex != eventSpacesToShow.length-1"
                size="small"
                width="fit-content"
                class=""
                variant="text"
                append-icon="mdi-arrow-down"
                density="compact"
                v-bind="props"
                @click="reorderEventSpace(item, 1)"
              />
            </template>
          </div>
        </div>
      </template>
    </div>

    <div
      v-if="!editingEventSpace && !editingEventDescription && (myUser?.userLevel == 'admin' || myPermission) && restaurant"
      class="text-center mt-2"
    >
      <VBtn
        size="small"
        width="fit-content"
        class="profile-header-edit-button"
        variant="text"
        prepend-icon="mdi-plus"
        density="compact"
        @click="newEventSpace"
      >
        Post Space(s)
      </VBtn>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.eventSpace-grid {
  display: grid;
  //grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  grid-template-columns: repeat(1, 1fr);
}
//@media (max-width: 868px) { /* Adjust 768px based on your breakpoint needs */
//  .eventSpace-grid {
//    /* Ensure 3 items per row on smaller screens */
//    grid-template-columns: repeat(1, 1fr);
//  }
//}

.admin-button-holder {
  float: right;
  bottom: 28px;
  position: relative;
}

.admin-reservation-menu-button {
  position: relative;
  float: right;
  top: 0;
  right: 0;
}


.avatar {
  cursor: pointer;
  position: relative;
  width: 6rem;
  height: 6rem;
  background: var(--ds-brand-primary-light);
}


@media screen and (min-width: 670px) {
  .avatar {
    width: 6rem;
    height: 6rem;
    outline-offset: 0.5rem;
    margin: 1rem 2rem 0;
  }

  .avatar:hover {
    filter: brightness(0.8);
  }
}

.avatar-fallback {
  width: 100%;
  height: 100%;
  font-size: 1.6rem;
}
@media screen and (min-width: 670px) {
  .avatar-fallback {
    font-size: 2rem;
  }
}

.avatar-image {
  width: 100%;
  height: 100%;
}

.avatar-camera-icon-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -6%;
  right: -6%;
  z-index: 10;
  padding: 0.4rem;
  background: var(--ds-surface-inset);
  border-radius: 50%;
}

.avatar-camera-icon {
  width: 1.2rem;
  height: 1.2rem;
  transform: translateY(1px);
}

.avatar-fallback-text {
  width: fit-content;
}

.eventSpaceImageContainer {
  width: 100%;
  position: relative;
  display: inline-block; // or 'block' depending on your layout needs

  .eventSpaceImage {
    display: block; // Ensure the image does not have extra space below it
    width: 100%; // Adjust as necessary
    height: auto; // Adjust as necessary
    max-height: 300px;
    object-fit: cover;
  }

  .eventSpaceTitle {
    position: absolute;
    bottom: 0;
    left: 0;
    color: white;
    padding-left: 8px; // Adjust as necessary
    padding-bottom: 3px; // Adjust as necessary
    z-index: 2; // Ensure the title is above the gradient overlay
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(7deg , rgba(0, 0, 0, 0.5) 10%, rgba(0, 0, 0, 0) 30%);
    z-index: 1; // Below the title, but above the image
  }
}

.space-card{
  margin: 1rem;
  padding: 1rem;
  border: 1px solid var(--ds-border-default);
  border-radius: 0.3rem;
  box-shadow: 0px 0px 6px rgba(0,0,0,0.1);
}
</style>
